export default __webpack_public_path__ + "3a81d34b10b50767052066892b2ac6b7.png";